'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$13() {
  this.avS = null;
  this.avT = false;
}
export { $c_Lpresto_AgentView$$anon$13 as $c_Lpresto_AgentView$$anon$13 };
$p = $c_Lpresto_AgentView$$anon$13.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$13;
/** @constructor */
function $h_Lpresto_AgentView$$anon$13() {
}
export { $h_Lpresto_AgentView$$anon$13 as $h_Lpresto_AgentView$$anon$13 };
$h_Lpresto_AgentView$$anon$13.prototype = $p;
$p.P = (function() {
  if ((!this.avT)) {
    this.avS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.avT = true;
  }
  return this.avS;
});
var $d_Lpresto_AgentView$$anon$13 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$13, "presto.AgentView$$anon$13", ({
  Dz: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_AgentView$$anon$13 as $d_Lpresto_AgentView$$anon$13 };
//# sourceMappingURL=presto.-Agent-View$$anon$13.js.map
